import useSWR from "swr";

export interface EventLayout {
  name: string;
  id: string;
}

export function useGetPartnerEventLayouts(offeringId: string): {
  data?: EventLayout[];
} {
  const response = useSWR(`/api/v2/partner_offerings/${offeringId}/layouts`);

  return { data: response.data?.map(toLayout) };
}

function toLayout(data?: any): EventLayout | undefined {
  if (data) {
    return {
      id: data.id,
      name: data.name,
    };
  }
}
